import PropTypes from 'prop-types'
import React, { useCallback } from 'react'

import { ParallaxTitle, SectionContainer, SectionUptitle } from '../../../components'
import Portfolio from '../../../components/Portfolio'
import { chainDecorators, memoized } from '../../../utils/ReactUtils'

import styles from './styles'
import { transformDomainRoutes } from '../../../helpers/RouteHelpers'
import MenuLink from '../../../components/Menu/MenuLink'
import MenuImage from '../../../components/Menu/MenuImage'
import { useState } from 'react'
import { useMousePosition } from '../../../hooks'


const decorators = [
  memoized,
]

function HomeProjects(props) {
  const { title, floatingTitle, webCta, locale, onDisplayProjects, activeRoute, t, domains } = props
  const routesInfosEnhanced = transformDomainRoutes(domains, locale, activeRoute)
  const [imageActiveIndex, setImageActiveIndex] = useState()
  const mousePosition = useMousePosition()

  const mouseEnterHandler = useCallback((index) => {
    setImageActiveIndex(index)
  }, [])

  const mouseLeaveHandler = useCallback(() => {
    setImageActiveIndex(-1)
  }, [])

  return (
    <SectionContainer className="portfolio">
      <div className='title'>
        <SectionUptitle
          title={title}
        />
        <ParallaxTitle title={floatingTitle} />
      </div>
      <Portfolio
        projects={onDisplayProjects}
        locale={locale}
        displaySwiperNavigation
      />
      <div className='routes'>
        <SectionUptitle title={webCta} />
          <ul role={'menubar'}>
            {routesInfosEnhanced.map((routeInfo, index) => (
              <MenuLink
                key={routeInfo.name}
                route={routeInfo.route}
                routeParams={routeInfo.routeParams}
                link={routeInfo.link}
                label={routeInfo.name}
                selected={routeInfo.active}
                target={routeInfo.route ? '_self' : '_blank'}
                onMouseEnter={() => mouseEnterHandler(index)}
                onMouseLeave={() => mouseLeaveHandler()}
              />
            ))}
          </ul>
          <div className="links-media">
            {routesInfosEnhanced.map(({ image }, index) => <MenuImage key={index} image={image.fluid} isActive={index === imageActiveIndex} x={mousePosition.x} y={mousePosition.y} />)}
          </div>
      </div>
      <style jsx>{styles}</style>
    </SectionContainer>
  )
}

HomeProjects.propTypes = {
  title: PropTypes.string,
  floatingTitle: PropTypes.string,
  webCta: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  onDisplayProjects: PropTypes.array,
  locale: PropTypes.string.isRequired,
  activeRoute: PropTypes.string,
  t: PropTypes.func,
}

HomeProjects.defaultProps = {
  title: '',
  webCta: '',
  onDisplayProjects: [],
  domains: [],
  activeRoute: '',
  t: () => null,
}

HomeProjects = chainDecorators(decorators, HomeProjects)

export default HomeProjects
